<header class="topbar">
  <a
    class="brand"
    [routerLink]="homeUrl()"
    [aria-label]="translationKeys.SHARED.HEADER.ARIA_LABELS.GO_TO_HOME | translate"
  >
    <div class="brand-mark">
      <span class="material-symbols-rounded">home_and_garden</span>
    </div>

    <div class="brand-meta">
      <span class="brand-title">{{ translationKeys.SHARED.HEADER.LOGO.TITLE | translate }}</span>
      <span class="brand-sub">AI / Estimative Engine</span>
    </div>
  </a>

  <nav class="menu-links">
    <button
      *appPermissionGate="managePermissions; match: 'any'"
      class="menu-link"
      type="button"
      routerLink="/computo-metrico/create"
      routerLinkActive="menu-link--active"
      [routerLinkActiveOptions]="{ exact: false }"
    >
      <span class="material-symbols-rounded">upload_file</span
      >{{ translationKeys.SHARED.HEADER.MENU.CREATE | translate }}
    </button>
    <button
      *appPermissionGate="accessPermissions; match: 'any'"
      class="menu-link"
      type="button"
      routerLink="/computo-metrico/list"
      routerLinkActive="menu-link--active"
      [routerLinkActiveOptions]="{ exact: false }">
      <span class="material-symbols-rounded">folder_open</span>{{ translationKeys.SHARED.HEADER.MENU.LIST | translate }}
    </button>
    <button
      *appPermissionGate="adminPermissions; match: 'any'"
      class="menu-link"
      type="button"
      routerLink="/amministrazione/utenti"
      routerLinkActive="menu-link--active">
      <span class="material-symbols-rounded">manage_accounts</span>
      {{ translationKeys.ADMINISTRATION.BREADCRUMB.USERS_AND_PERMISSIONS | translate }}
    </button>
  </nav>

  <div class="top-actions">
    <div class="account-menu">
      <button
        class="user-chip"
        type="button"
        aria-label="Apri il menu account"
        aria-haspopup="menu"
        [attr.aria-expanded]="profileMenuOpen()"
        (click)="toggleProfileMenu($event)"
      >
        <span class="user-avatar">{{ userAvatar() }}</span>
        <span>{{ profile()?.name }} {{ profile()?.surname }}</span>
        <span class="material-symbols-rounded account-menu-chevron" aria-hidden="true">
          keyboard_arrow_down
        </span>
      </button>

      @if (profileMenuOpen()) {
        <div class="account-menu-panel" role="menu" (click)="$event.stopPropagation()">
          <a role="menuitem" routerLink="/account" (click)="closeProfileMenu()">
            <span class="material-symbols-rounded" aria-hidden="true">person</span>
            {{ translationKeys.ACCOUNT.BREADCRUMB.ACCOUNT | translate }}
          </a>
          <a role="menuitem" routerLink="/change-password" (click)="closeProfileMenu()">
            <span class="material-symbols-rounded" aria-hidden="true">key</span>
            {{ translationKeys.CHANGE_PASSWORD.AUTHENTICATED_TITLE | translate }}
          </a>
          <button type="button" role="menuitem" (click)="logOut()">
            <span class="material-symbols-rounded" aria-hidden="true">logout</span>
            {{ translationKeys.LOGOUT.BADGE | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</header>
